import { createAchCheckBillPaymentStatus } from '../../../../../helpers/createAchCheckStatus';

export const createAchCheckLabels = (billPayment) => {
  return [
    {
      title: 'ACH Status',
      isVisible: () => billPayment?.source === 'ACH',
      value: () => {
        return createAchCheckBillPaymentStatus(billPayment);
      },
    },
    {
      title: 'Check Status',
      isVisible: () => billPayment?.source === 'Check',
      value: () => {
        return createAchCheckBillPaymentStatus(billPayment);
      },
    },
  ];
};

export const isOnlyReferenceEditable = (billPayment) => {
  if (!billPayment) {
    return false;
  }

  return (
    billPayment.status !== 'unapplied' &&
    (billPayment.source !== 'Check' ||
      billPayment?.status !== 'unapplied' ||
      !!billPayment?.billcom_sentpay_id) &&
    !!billPayment?.billcom_sentpay_id &&
    (billPayment.source !== 'Check' ||
      billPayment.check_use_billcom ||
      billPayment.check_use_lob)
  );
};
